import React, { useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import styled from "styled-components";
import Lottie from 'lottie-react-web';

import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
import FetchModule from "../../../Model/Network/FetchModule";

export default function WodDetailRoute(props) {

  const navigate = useNavigate();
  const params = useParams();

  // 페이지가 갈곳 정하기 //
  useEffect(() => {
    let eventId = params.eventId;
    let token = params.token;

    if (token !== undefined) window.localStorage.setItem('Token', 'Bearer ' + token);
    // alert(token);
    // navigate('/detail_wod/' + eventId);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfEventVer2('event/available_wod/' + eventId, 'GET');
        
        if (responseData.status === 200) navigate('/detail_wod/' + eventId);
        else if (responseData.status === 201) navigate('/complete/v2/' + eventId);
      }
    )();
  }, [])
  
  return (
    <TopLevelWrapper>
      <LottieWrapper>
        <LottieBox>
          <Lottie options={{ animationData: LoadingAnimation }} />
        </LottieBox>
        {/* <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000'>Loading payment module...</Text> */}
      </LottieWrapper>
    </TopLevelWrapper>
  )
}


const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;

  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const LottieBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 60px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize};

  color: ${props => props.color};

  margin: 0 0 0 0;
`;